module.exports = __webpack_public_path__ + "img/code_img.6047fd9a.jpg";